import type { ReactNode } from 'react';
import { Check } from 'lucide-react';
import type { Kit } from '@/data/kits';
import { Button, buttonVariants } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface KitDetailModalProps {
  kit: Kit;
  children: ReactNode;
}

export function KitDetailModal({ kit, children }: KitDetailModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent aria-describedby={`kit-${kit.id}-desc`}>
        <DialogHeader>
          <DialogTitle>Kit {kit.name}</DialogTitle>
          <DialogDescription id={`kit-${kit.id}-desc`}>Ideal para {kit.idealFor}</DialogDescription>
        </DialogHeader>
        <Tabs defaultValue="specs">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="specs">Especificaciones</TabsTrigger>
            <TabsTrigger value="monitoring">Monitoreo 24/7</TabsTrigger>
          </TabsList>
          <TabsContent value="specs">
            <ul className="space-y-2">
              {kit.includes.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </TabsContent>
          <TabsContent value="monitoring">
            <p className="text-sm text-muted-foreground">{kit.monitoring}</p>
          </TabsContent>
        </Tabs>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cerrar</Button>
          </DialogClose>
          <DialogClose asChild>
            <a href="#quotation" className={buttonVariants()}>
              Solicitar Cotización
            </a>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
